//slice to generate annual return
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { generateAnnualReturnDataService } from "services/generateAnnualReturnDataService";

const initialState = {
  generatedAnnualRetuns: {
    items: [],
    totalCount: 0,
  },
  generateAnnualReturn: {
    status: "idle",
    error: false,
  },
};

export const generateAnnualReturnAsync = createAsyncThunk(
  "generateAnnualReturn/create",
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await generateAnnualReturnDataService.create(data);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const generateAnnualReturnSlice = createSlice({
  name: "generateAnnualReturn",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(generateAnnualReturnAsync.pending, (state) => {
        state.generateAnnualReturn.status = "loading";
      })
      .addCase(generateAnnualReturnAsync.fulfilled, (state, action) => {
        state.generateAnnualReturn.status = "succeeded";
        state.generatedAnnualRetuns.items.push(action.payload);
      })
      .addCase(generateAnnualReturnAsync.rejected, (state, action) => {
        state.generateAnnualReturn.status = "failed";
        state.generateAnnualReturn.error = action.error.message;
      });
  },
});

export default generateAnnualReturnSlice.reducer;
